<template>
  <van-popup v-model="onShow" position="bottom" class="pay-popup">
    <van-row align="center" class="pay-header">
      <van-col
        :class="['pay-subtitle2', selectedPayment.ServiceFee ? 'isFee' : '']"
        v-if="selectedPayment.IsActivateFirstOrderDiscountPromotion"
      >
        <span class="boxUnit">{{ selectedPayment.CurrencySymbol }}</span>
        <span class="discountAmount">{{ getDiscountAmount() }}</span>
        <span class="fee" v-if="selectedPayment.ServiceFee"
          >&nbsp;+&nbsp;{{ $t.orderDetail.serviceFee }}:{{
            selectedPayment.ServiceFee
          }}</span
        >
        <div class="originalAmount">
          {{ selectedPayment.CurrencySymbol }}&nbsp;{{ getOriginalPrice() }}
        </div>
      </van-col>
      <van-col
        :class="['pay-subtitle1', selectedPayment.ServiceFee ? 'isFee' : '']"
        v-else
      >
        <span class="boxUnit">{{ selectedPayment.CurrencySymbol }}</span>
        <span class="amount">
          {{ getOriginalPrice() }}
        </span>
        <span class="fee" v-if="selectedPayment.ServiceFee"
          >&nbsp;+&nbsp;{{ $t.orderDetail.serviceFee }}:{{
            selectedPayment.ServiceFee
          }}</span
        >
      </van-col>
      <van-col class="pay-title">{{ $t.orderDetail.payType }}</van-col>
    </van-row>

    <div class="paymentBox">
      <van-radio-group v-model="paymentMethod">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in paymentItems"
            :key="index"
            :title="item.paymentName"
            clickable
            @click="onSelect(item)"
          >
            <template #icon>
              <img
                :src="require('@/assets/img/order/' + item.icon + '.png')"
                class="pay-icon"
              />
            </template>
            <template #right-icon>
              <div
                class="pay-discount"
                v-if="selectedPayment.IsActivateFirstOrderDiscountPromotion"
              >
                {{ $t.orderDetail.discount }}&nbsp;{{ selectedPayment.CurrencySymbol
                }}{{ selectedPayment.DiscountAmount }}<van-icon name="arrow" />
              </div>
              <van-radio :name="item.paymentMethod" checked-color="#009ed4"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>

    <div class="pointsBox" v-if="selectedPayment.CurrencySn == 'CNY'">
      <van-cell
        :title="$t.orderDetail.availablePoints + ' : ' + selectedPayment.AvailablePoints"
      >
        <template #right-icon>
          <span class="pointsBox-text"
            >- {{ selectedPayment.CurrencySymbol }}
            {{ selectedPayment.DeductibleAmount }}</span
          >
          <van-switch
            v-model="selectedPayment.IsUsePointsDeduction"
            :disabled="!selectedPayment.DeductibleAmount ? true : false"
            size="20"
          />
        </template>
      </van-cell>
    </div>

    <div class="submitBox" @click="onPay">
      <div class="submit">{{ $t.orderDetail.onPay }}</div>
    </div>
  </van-popup>
</template>
<script>
import Vue from "vue";
import { Cell, CellGroup, Popup, Radio, RadioGroup, Switch, Icon } from "vant";
Vue.use(Popup).use(Cell).use(CellGroup).use(Radio).use(RadioGroup).use(Switch).use(Icon);

export default {
  name: "PayWindow",
  props: ["WB_Number"],
  data() {
    return {
      paymentMethod: 1,
      paymentOptions: [
        {
          paymentName: this.$t.orderDetail.paymentOption1,
          paymentMethod: 1,
          icon: "alipay",
        },
        {
          paymentName: this.$t.orderDetail.paymentOption2,
          paymentMethod: 2,
          icon: "wechat",
        },
        {
          paymentName: "FLYPAY",
          paymentMethod: 3,
          icon: "flypay",
        },
      ],
      paymentItems: [],
      selectedPayment: {
        SCId: null,
        UCId: null,
        CurrencySn: "",
        CurrencySymbol: "",
        TotalAmountDue: 0,
        ServiceFee: 0,
        AvailablePaymentMethods: [],
        //积分
        AvailablePoints: 0,
        DeductibleAmount: 0,
        IsUsePointsDeduction: false,
      },
      onShow: false,
    };
  },
  created() {
    this.$bus.$off("showPayWindow").$on("showPayWindow", (data) => {
      this.onShow = true;
      this.initData();
      if (data.paymentData) {
        for (var payment of this.paymentOptions) {
          var methods = data.paymentData.AvailablePaymentMethods.find(
            (p) => p.Value == payment.paymentMethod
          );
          this.paymentMethod = parseInt(
            data.paymentData.AvailablePaymentMethods[0].Value
          );
          //总金额
          var totalAmount = data.paymentData.TotalAmountDue;
          //折扣金额
          var discountedAmount = data.paymentData.DiscountedAmount;
          //商品金额
          var productAmount = 0;
          if (data.productData) {
            productAmount = data.productData.CnyPrice;
          }
          var concatData = {
            SCId: data.paymentData.SCId,
            UCId: data.productData ? data.productData.UCId : null,
            CurrencySn: data.paymentData.CurrencySn,
            CurrencySymbol: data.paymentData.CurrencySymbol,
            DiscountAmount: data.paymentData.DiscountAmount,
            DiscountedAmount: discountedAmount,
            TotalAmountDue: totalAmount,
            ProductAmount: productAmount,
            AvailablePaymentMethods: data.paymentData.AvailablePaymentMethods,
            AvailablePoints: data.paymentData.AvailablePoints,
            DeductibleAmount: data.paymentData.DeductibleAmount,
            IsActivateFirstOrderDiscountPromotion:
              data.paymentData.IsActivateFirstOrderDiscountPromotion,
          };
          if (methods) {
            if (methods.Value == 1) {
              var content = {
                paymentMethod: 1,
                icon: "alipay",
                paymentName: this.$t.orderDetail.paymentOption1,
              };
              var item = { ...content, ...concatData };
              this.paymentItems.push(item);
            }
            if (methods.Value == 2) {
              var content = {
                paymentMethod: 2,
                icon: "wechat",
                paymentName: this.$t.orderDetail.paymentOption2,
              };
              var item = { ...content, ...concatData };
              this.paymentItems.push(item);
            }
            if (methods.Value == 3) {
              var content = {
                paymentMethod: 3,
                icon: "flypay",
                paymentName: "Flyway",
              };
              var item = { ...content, ...concatData };
              this.paymentItems.push(item);
            }
            this.selectedPayment = concatData;
            this.getFee();
          }
        }
      }
    });
  },
  methods: {
    getDiscountAmount() {
      var amount = 0;
      if (this.selectedPayment.IsUsePointsDeduction) {
        amount =
          this.selectedPayment.DiscountedAmount -
          this.selectedPayment.DeductibleAmount +
          this.selectedPayment.ProductAmount;
      } else {
        amount =
          this.selectedPayment.DiscountedAmount + this.selectedPayment.ProductAmount;
      }
      return amount.toFixed(2);
    },
    getOriginalPrice() {
      var amount = 0;
      if (this.selectedPayment.IsUsePointsDeduction) {
        amount =
          this.selectedPayment.TotalAmountDue -
          this.selectedPayment.DeductibleAmount +
          this.selectedPayment.ProductAmount;
      } else {
        amount = this.selectedPayment.TotalAmountDue + this.selectedPayment.ProductAmount;
      }
      return amount.toFixed(2);
    },
    getFee() {
      for (var method of this.selectedPayment.AvailablePaymentMethods) {
        if (this.paymentMethod == method.Value && method.ServiceFee) {
          this.selectedPayment.ServiceFee = method.ServiceFee;
          break;
        } else {
          this.selectedPayment.ServiceFee = 0;
        }
      }
    },
    initData() {
      this.paymentMethod = 1;
      this.paymentItems = [];
      this.selectedPayment = {
        SCId: null,
        UCId: null,
        CurrencySn: "",
        CurrencySymbol: "",
        TotalAmountDue: 0,
        ServiceFee: 0,
        AvailablePaymentMethods: [],
        //积分
        AvailablePoints: 0,
        DeductibleAmount: 0,
        IsUsePointsDeduction: false,
      };
    },
    onSelect(item) {
      this.paymentMethod = item.paymentMethod;
      this.selectedPayment = item;
      if (this.selectedPayment.IsUsePointsDeduction) {
        this.selectedPayment.IsUsePointsDeduction = false;
      }
      this.getFee();
    },
    onPay() {
      this.paymentCollectionBill();
      this.onShow = false;
    },
    paymentCollectionBill() {
      this.$commonMethod.showLoading();
      let param = {
        WB_Number: this.WB_Number,
        SCId: this.selectedPayment.SCId,
        UCId: this.selectedPayment.UCId,
        PaymentMethod: this.paymentMethod,
        IsUsePointsDeduction: this.selectedPayment.IsUsePointsDeduction ? 1 : 0,
      };
      this.$api.order
        .paymentCollectionBill(param)
        .then((res) => {
          const url = res.data;
          if (url) {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.gotoPay, {
              url: url,
            });
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.pay-popup {
  height: auto;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  padding-bottom: env(safe-area-inset-bottom);
  .pay-header {
    width: auto;
    padding: 5%;
    border-bottom: 1px solid #ebedf0;
    .pay-title {
      width: 100%;
      text-align: center;
      font-size: 12px;
    }
    .isFee {
      width: 90% !important;
      margin-left: 10% !important;
      .originalAmount {
        margin-right: 11% !important;
      }
    }
    .pay-subtitle1 {
      width: 100%;
      text-align: center;
      font-weight: bold;
      font-size: 2rem;
      margin-top: 10px;
      margin-bottom: 20px;
      margin-left: 0%;
      .amount {
        font-size: 2rem;
        font-weight: bold;
        color: #000;
        vertical-align: middle;
      }
    }
    .pay-subtitle2 {
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
      margin-left: 0px;
      .discountAmount {
        font-size: 2rem;
        font-weight: bold;
        color: #000;
        vertical-align: middle;
      }
      .originalAmount {
        margin-top: 5px;
        font-size: 14px;
        font-weight: normal;
        color: red;
        text-decoration: line-through;
      }
    }
    .boxUnit {
      font-size: 1.5rem;
      vertical-align: middle;
    }
    .fee {
      font-size: 14px;
      font-weight: normal;
      color: green;
    }
  }
  .pay-icon {
    width: 25px;
    height: 25px;
    margin-right: 10px;
  }
  .pay-discount {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    margin-top: 1px;
    margin-right: 10px;
    color: red;
    border: 1px solid red;
    border-radius: 5px;
    padding: 0px 5px;
  }
  .paymentBox {
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .van-cell::after {
      border: none !important;
    }
    .van-cell-group::after {
      border: none !important;
    }
  }
  .pointsBox {
    .van-cell {
      padding: 16px 16px 0px 16px;
      .van-switch--on {
        background-color: #009ed4 !important;
      }
      .van-cell__title {
        font-size: 12px;
      }
      .pointsBox-text {
        font-size: 12px;
        margin-right: 10px;
      }
    }
  }
  .submitBox {
    padding: 5%;
    .submit {
      position: relative;
      width: 100%;
      border-radius: 3rem;
      padding: 0.8rem 0;
      text-align: center;
      background: linear-gradient(left, #009ed4, #5029c3);
      color: #ffffff;
      font-size: 1rem;
      line-height: 1;
    }
  }
}
</style>
